import i18n, { type i18n as I18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, LOCALES, type Locale } from '@ceo/shared';
import en from './en.json';
import sq from './sq.json';

export const resources = { en: { translation: en }, sq: { translation: sq } } as const;

declare module 'i18next' {
  interface CustomTypeOptions {
    resources: (typeof resources)['en'];
  }
}

void i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  initAsync: false,
});

/**
 * One i18next instance per locale (sharing the same resource store). The locale comes from
 * the URL, so each layout gets its own instance instead of mutating a global language.
 */
const instances = Object.fromEntries(
  LOCALES.map((l) => [l, i18n.cloneInstance({ lng: l, initAsync: false })]),
) as Record<Locale, I18n>;

export const i18nFor = (locale: Locale) => instances[locale];

export default i18n;
